import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  useBreakpointValue,
} from '@chakra-ui/react'
import _ from 'lodash'

import BrandButton from 'src/components/widgets/buttons/BrandButton/BrandButton'
import { asPrice } from 'src/lib/utils'
import { BrandColor } from 'src/types'

import { BuyOptions } from '../../..'
import { Statistics } from '../getItListItemsCountByType'
import { InsideItems } from '../Inside'

const PaywalledItListInside: React.FC<{
  currentInside: Statistics
  uiData: InsideItems
  creatorName: string
  creatorNamePossessive: string
  brandColor: BrandColor
  buyIsLoading: boolean
  withEmailPaywall: boolean
  price: number
  buy(options?: BuyOptions): unknown
}> = ({
  currentInside,
  uiData,
  creatorName,
  creatorNamePossessive,
  brandColor,
  buyIsLoading,
  withEmailPaywall,
  price,
  buy,
}) => {
  const isSmMd = useBreakpointValue({ sm: true, lg: false })
  if (isSmMd === undefined) return null

  return (
    <Accordion allowToggle>
      {currentInside
        .filter(({ count }) => count > 0)
        .map(({ label, count }) => {
          const itemDefinition = uiData[label]
          const itemLabel =
            count === 1 ? itemDefinition.label : itemDefinition.plural
          return (
            <AccordionItem
              key={label}
              mb={3}
              borderRadius={16}
              boxShadow="sm"
              borderColor="vapor"
              data-testid={`inside-item-${label}`}
            >
              <AccordionButton p={3} _hover={{ bg: 'transparent' }}>
                <Box>{itemDefinition.icon}</Box>
                <Box flex="1" mx={6} textAlign="left">
                  <Box as="h5" className="thick" display="inline">
                    {count}
                  </Box>
                  <Box display="inline" ml="2" className="body-small">
                    {itemLabel}
                  </Box>
                </Box>
                <AccordionIcon color="graphite" />
              </AccordionButton>
              <AccordionPanel p={3}>
                <Box color="stone" className="body-small" mb={8}>
                  {itemDefinition.description({
                    count,
                    creatorName,
                    creatorNamePossessive,
                  })}
                </Box>
                {(!withEmailPaywall || isSmMd) && (
                  <BrandButton
                    variant="light"
                    brandColor={brandColor}
                    borderRadius="full"
                    data-testid="itListAccordion-buy-button"
                    w="full"
                    flex={1}
                    isLoading={buyIsLoading}
                    onClick={() => {
                      buy()
                    }}
                  >
                    Get this ItList{!withEmailPaywall && ` - ${asPrice(price)}`}
                  </BrandButton>
                )}
              </AccordionPanel>
            </AccordionItem>
          )
        })}
    </Accordion>
  )
}

export default PaywalledItListInside
